module.exports = __webpack_public_path__ + "static/media/hit.5702b916.mp3";